// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import {
  StyledMobileBoxItem,
  StyledMobileBoxItemRow,
  StyledMobileBoxLabel,
} from '../../utils/Styles/DataBoxStyles';
import { getTravelType } from '../../forms/events/EventManager';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const TravelListMobile = ({ events, handleOnClick, getDestination }) => {
  return (
    <div>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {events.map(event => {
        const { from, to } = getDestination(event);
        return (
          <StyledMobileBoxItem
            key={event.eventId}
            data-eventid={event.eventId}
            onClick={handleOnClick}
          >
            <StyledMobileBoxLabel>
              {getTravelType(event.flightType)}
            </StyledMobileBoxLabel>
            <StyledMobileBoxItemRow>
              From: <span>{from}</span>
            </StyledMobileBoxItemRow>
            <StyledMobileBoxItemRow>
              To: <span>{to}</span>
            </StyledMobileBoxItemRow>
          </StyledMobileBoxItem>
        );
      })}
    </div>
  );
};

export default TravelListMobile;
